import { render, staticRenderFns } from "./Ratings.html?vue&type=template&id=66b59ade&external"
import script from "./Ratings.js?vue&type=script&lang=js&external"
export * from "./Ratings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports